/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBlockLines: {
  name: 'block-lines';
  data: string;
} = {
  name: 'block-lines',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Zm2 11v3h14v-3H5Zm14-2H5v-4h14v4Zm0-9v3H5V5h14Z" fill="currentColor"/></svg>`,
};
